import React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import FinancingRequestStudentData from "../../../models/financing-request/student-data/FinancingRequestStudentData";
import { makeStyles, createStyles } from "@material-ui/styles";
import { Theme } from "@material-ui/core";
import { hrDate } from "../../../utilities/utilities";
import { ProgramType } from "../../../models/financing-request/ProgramType";
import useStudentDataInfo from "../../../hooks/student-data-info/useStudentDataInfo";

interface Props {
  studentData: FinancingRequestStudentData;
}

function StudentDataHeading({ studentData }: Props) {
  const classes = useStyles({});

  return (
    <>
      <Grid container spacing={2} className={classes.container}>
        <Grid item lg="auto" md={4} className={classes.column}>
          <Typography variant="body2" color="textSecondary">
            Učenik
          </Typography>
          <Typography variant="subtitle2">
            {studentData.student.lastName} {studentData.student.firstName}
          </Typography>
          <Typography variant="subtitle2">
            {hrDate(studentData.student.birthDate)}
          </Typography>
        </Grid>
        <Grid item lg="auto" md={4} className={classes.column}>
          <Typography variant="body2" color="textSecondary">
            OIB
          </Typography>
          <Typography variant="subtitle2">{studentData.student.oib}</Typography>
        </Grid>
        <Grid item lg="auto" sm={4} className={classes.largeColumn}>
          <Typography variant="body2" color="textSecondary">
            Razred
          </Typography>
          <Typography variant="subtitle2">
            {studentData.student.programName}
          </Typography>
          <Typography variant="subtitle2">
            {studentData.student.schoolClass +
              " - " +
              studentData.student.sectionMark}
          </Typography>
        </Grid>
        <Grid item lg="auto" sm={3} className={classes.largeColumn}>
          <Typography variant="body2" color="textSecondary">
            Vrsta odjeljenja
          </Typography>
          <Typography variant="subtitle2">
            {studentData.student.sectionTypeName}
          </Typography>
        </Grid>
        <Grid item lg="auto" sm={3} className={classes.column}>
          <Typography variant="body2" color="textSecondary">
            Prijevoz
          </Typography>
          <Typography variant="subtitle2">
            {studentData.transportOptionInfo || "-"}
          </Typography>
        </Grid>
        {studentData.student.programType == ProgramType.Elementary ? (
          <Grid item lg="auto" sm={3} className={classes.column}>
            <Typography variant="body2" color="textSecondary">
              Prehrana
            </Typography>
            <Typography variant="subtitle2">
              {studentData.foodOptionInfo || "-"}
            </Typography>
          </Grid>
        ) : (
          <></>
        )}

        <Grid item lg="auto" sm={3} className={classes.column}>
          <Typography variant="body2" color="textSecondary">
            Posebna nastavna sredstva i pomagala
          </Typography>
          <Typography variant="subtitle2">
            {studentData.teachingAidOptionInfo || "-"}
          </Typography>
        </Grid>
      </Grid>
    </>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    column: {
      display: "flex",
      alignItems: "start",
      flexDirection: "column",
      flexGrow: 1,
      flexBasis: 0
    },
    largeColumn: {
      display: "flex",
      alignItems: "start",
      flexDirection: "column",
      flexGrow: 1.5,
      flexBasis: 0
    },
    container: {
      justifyContent: "space-between",
      padding: "0"
    },
    full: {
      width: "100%"
    },
    label: {}
  })
);

function areEqual(prevProps: Props, nextProps: Props) {
  return prevProps.studentData === nextProps.studentData;
}

export default React.memo(StudentDataHeading, areEqual);
